import { axiosInstance } from "../../utils";

const actions = {
  FETCH_SUBCATEGORIES_REQUESTED: "FETCH_SUBCATEGORIES_REQUESTED",
  FETCH_SUBCATEGORIES_SUCCEEDED: "FETCH_SUBCATEGORIES_SUCCEEDED",
  FETCH_SUBCATEGORIES_FAILED: "FETCH_SUBCATEGORIES_FAILED",

  DELETE_SUBCATEGORY_REQUESTED: "DELETE_SUBCATEGORY_REQUESTED",
  DELETE_SUBCATEGORY_SUCCEEDED: "DELETE_SUBCATEGORY_SUCCEEDED",
  DELETE_SUBCATEGORY_FAILED: "DELETE_SUBCATEGORY_FAILED",

  CLEAR_ALERT_MESSAGE: "CLEAR_ALERT_MESSAGE",

  CLEAR_DATA: "CLEAR_DATA",

  clearData: (params = undefined) => {
    return {
      type: actions.CLEAR_DATA,
      payload: params,
    };
  },

  clearAlertMessage: (params = undefined) => {
    return {
      type: actions.CLEAR_ALERT_MESSAGE,
      payload: params,
    };
  },

  fetchSubCategories: (params = undefined) => {
    return {
      type: actions.FETCH_SUBCATEGORIES_REQUESTED,
      payload: params,
    };
  },

  removeSubCategory: (id = undefined) => {
    return {
      type: actions.DELETE_SUBCATEGORY_REQUESTED,
      payload: id,
    };
  },

  getSubCategories: async (params = undefined) => {
    const url = `categories`;
    let res = { parent_id: params.parent_id };

    try {
      const subCategories = await axiosInstance.get(url, {
        params: {
          ...params,
          is_sub: true,
          sort_field: "name",
          sort_type: "asc",
        },
      });
      return { ...res, ...subCategories.data };
    } catch (error) {
      throw error;
    }
  },

  deleteSubCategory: async (id = undefined) => {
    const url = `categories/` + id;

    try {
      const response = await axiosInstance.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
